import React, { } from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';

function DialogChooseVersion({ open, onClose }) {
    const translate = useTranslate();

    return (
        <Dialog
            open={open}
            onClose={() => onClose(false)}
            disableBackdropClick
            disableEscapeKeyDown
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{translate('resources.infoPage.new_version_title')}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">{translate('resources.infoPage.new_version_content')}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose(false)} color="primary">{translate('resources.infoPage.override')}</Button>
                <Button onClick={() => onClose(true)} color="primary">{translate('resources.infoPage.keep_working')}</Button>
            </DialogActions>
        </Dialog>
    );
}

DialogChooseVersion.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default DialogChooseVersion;
